import { environment as base } from './environment.base';

export const environment = {
  ...base,
  name: 'dev',
  openTelemetry: {
    ...base.openTelemetry,
    commonConfig: {
      ...base.openTelemetry.commonConfig,
      serviceName: 'spotlight-frontend-dev',
    },
    otelcolConfig: {
      ...base.openTelemetry.otelcolConfig,
      url: 'https://opentelemetry.semantria.com:4318/v1/traces',
    },
  },
};
